export default "__VITE_ASSET__DKSRkbHY__"